import request from '@/utils/request'

export function getmcmctp() {
  return request({
    url: `/api/mcmctp/many`,
    method: 'post',
  })
}
